import script from "./FixtureSkeletonLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./FixtureSkeletonLoader.vue?vue&type=script&setup=true&lang=js"

import "./FixtureSkeletonLoader.vue?vue&type=style&index=0&id=01c6784f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c6784f"]])

export default __exports__